module.exports = __webpack_public_path__ + "img/logo.f6e37bfd.png";